import { ProfileInfo } from '../components/common/props-types';
import config from '../config';

let registrationToken: string | null;

export const getRegistrationToken = (): string | null => {
  return registrationToken;
};

export const setRegistrationToken = (token: string | null): void => {
  registrationToken = token;
};

export const CreateAuth0Account = (email: string, password: string): Promise<any> => {
  const domain = config.AUTH0_DOMAIN || '';
  const clientId = config.AUTH0_CLIENT_ID || '';
  const connection = config.AUTH0_CONNECTION || '';

  const requestRegisterOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      connection: connection,
      client_id: clientId,
      email: email,
      password: password,
    }),
  };

  return fetch('https://' + domain + '/dbconnections/signup', requestRegisterOptions);
};

export const LoginAuth0AccountAPI = (email: string, password: string): Promise<any> => {
  const domain = config.AUTH0_DOMAIN || '';
  const clientId = config.AUTH0_CLIENT_ID || '';
  const audience = config.AUTH0_LOGIN_AUDIENCE || '';

  const requestLoginOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      grant_type: 'password',
      username: email,
      password: password,
      client_id: clientId,
      audience: audience,
    }).toString(),
  };

  return fetch('https://' + domain + '/oauth/token', requestLoginOptions);
};

export const CreateFLSAccount = (
  profileAuth: { sessionId: string; token: string },
  profile: ProfileInfo,
  auth0UserId: string,
  recaptchaToken: string,
  consentfamiliprixTC: boolean,
  consent14AndUp: boolean
): Promise<any> => {
  const domain = config.FLS_API_DOMAIN || '';

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + profileAuth.token,
      RecaptchaToken: recaptchaToken,
    },
    body: JSON.stringify({
      Lastname: profile.lastName,
      Firstname: profile.firstName,
      Phones: {
        CellPhone: profile.mobilePhone,
        OtherPhone: profile.homePhone,
      },
      Email: profile.email,
      Auth0UserId: auth0UserId,
      SessionId: profileAuth.sessionId,
      ConsentFamiliprixTC: consentfamiliprixTC,
      Consent14AndUp: consent14AndUp,
    }),
  };

  return fetch(domain + '/api/Profile', requestOptions);
};
